import React from "react";
import { Box, Button, TablePagination } from "@mui/material";
import { DotLottieReact } from "@lottiefiles/dotlottie-react"; 

const PaginationComponent = ({ count, page, rowsPerPage, onPageChange }) => {
  return (
    <TablePagination
      rowsPerPageOptions={[10]}
      component="div"
      count={count}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={onPageChange}
      ActionsComponent={() => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 4,
            overflow: "hidden",
            height: "auto",
          }}
        >
          {/* Previous Button with Reverse Animation */}
          <Button
            onClick={(event) => onPageChange(event, page - 1)}
            disabled={page === 0}
            sx={{
              padding: 0,
              backgroundColor: "transparent",
              "&:hover": { backgroundColor: "transparent" },
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <DotLottieReact
              src="https://lottie.host/7c2197e8-15fa-4874-b39c-b9fe33b7dd6b/HQAylzP3m1.lottie"
              loop
              autoplay
              style={{
                width: 600,
                height: 600,
                transform: "scaleX(-1)",
                
              }}
            />
          </Button>

          {/* Next Button with Forward Animation */}
          <Button
            onClick={(event) => onPageChange(event, page + 1)}
            disabled={page >= Math.ceil(count / rowsPerPage) - 1}
            sx={{
              padding: 0,
              backgroundColor: "transparent",
              "&:hover": { backgroundColor: "transparent" },
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <DotLottieReact
              src="https://lottie.host/7c2197e8-15fa-4874-b39c-b9fe33b7dd6b/HQAylzP3m1.lottie"
              loop
              autoplay
              style={{
                width: 600,
                height: 600,
              }}
            />
          </Button>
        </Box>
      )}
    />
  );
};

export default PaginationComponent;
